import { render } from "./miniAppServer.vue?vue&type=template&id=ba5595d0&scoped=true"
import script from "./miniAppServer.vue?vue&type=script&lang=js"
export * from "./miniAppServer.vue?vue&type=script&lang=js"

import "./miniAppServer.vue?vue&type=style&index=0&id=ba5595d0&scoped=true&lang=css"

import exportComponent from "E:\\Apangu\\TdServerMiniAppPortalWeb\\TdServerMiniAppPortalWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5595d0"]])

export default __exports__